import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { useSelector } from 'react-redux';
import { artikelGruppenSelector } from 'store/lookups/selector';
import { MultiSelect } from 'formComponents/Select/MultiSelect';

interface ArtikelGruppeByNrProps {
    label: string;
    disabled: boolean;
    values: number[];
    menuPlacement?: MenuPlacement;
    includeArchiv?: boolean;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange: (newValues: number[]) => void;
}

export const ArtikelGruppeByNrMultiple: React.FC<ArtikelGruppeByNrProps> = ({
    label,
    values,
    disabled,
    menuPlacement = 'bottom',
    includeArchiv = true,
    allowEmpty = false,
    renderLabel = 'label',
    onChange,
}) => {
    const artikelGruppen = useSelector(artikelGruppenSelector);

    const options = React.useMemo(() => {
        const o = artikelGruppen
            .filter((a) => includeArchiv || a.activeCount > 0)
            .sort((a, b) => a.text.localeCompare(b.text))
            .map((ag) => ({
                value: ag.nr.toString(),
                label: ag.text,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [artikelGruppen, allowEmpty, includeArchiv]);

    const selectedOptions = React.useMemo(
        () => options.filter((option) => values.includes(parseInt(option.value, 10))),
        [options, values],
    );

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <MultiSelect
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={selectedOptions}
                options={options}
                menuPlacement={menuPlacement}
                onChange={(newValues: ValueType<SelectOption, true>): void => {
                    onChange(((newValues || []) as SelectOption[]).map((option) => parseInt(option.value, 10)));
                }}
                placeholder={renderLabel === 'placeholder' ? label : ''}
            />
        </>
    );
};
